import { Breadcrumb, Layout, Menu, Dropdown, Button, Drawer } from 'antd';
import { DownloadOutlined, TranslationOutlined, UserOutlined, ZhihuOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../context/UserContext";
import { useEffect, useState } from "react";
import ApiService from "../../../service/api-service";
import { LocalStorageService } from "../../../service/local-storage-service";
import { useHistory } from "react-router-dom";
import { Pages } from "../../../../AppRouter";
import { useApp } from "../../../context/AppContext";
import { BrowserView, MobileView } from "react-device-detect";
import { useIsSmallScreen } from "../../../utils/useMediaQuery";

const { SubMenu } = Menu;

export default function ProfileDropdown() {
    const isSmallScreen = useIsSmallScreen(992);
    const { t } = useTranslation();
    const { signOut, setUser, user } = useUser();
    const history = useHistory()
    const [drawerOpen, setDrawerOpen] = useState(false);

    const onClick = (item) => {
        if (item.key === 'logout') {
            signOut()
        }
        else if (item.key === 'dictionary') {
            history.push(Pages.User.Dictionary)
            setDrawerOpen(false)
        }
        else if (['en', 'tr', 'uz', 'ru'].includes(item.key)) {
            LocalStorageService.setLanguage(item.key)
            window.location.reload()
        }
    }

    const menu = (
        <Menu onClick={onClick}>
            <SubMenu icon={<ZhihuOutlined />} key={'languages'} title={'Language'}>
                <Menu.Item key="en">
                    English
                </Menu.Item>
                <Menu.Item key="tr">
                    Türkçe
                </Menu.Item>
                <Menu.Item key="uz">
                    Uzbek
                </Menu.Item>
                <Menu.Item key="ru">
                    Русский
                </Menu.Item>
            </SubMenu>
            <Menu.Item key="dictionary" icon={<TranslationOutlined />}>
                {t('Dictionary')}
            </Menu.Item>
            <Menu.Item key="download-viewer" icon={<DownloadOutlined />}>
                <a href={`${window.AppSettings.server.api}/Public/launcher/ECloudpacsViewerInstaller.exe`} download>
                    {t('Viewer Download (Windows)')}
                </a>
            </Menu.Item>
            <Menu.Item key="logout" icon={<UserOutlined />}>
                {t('Logout')}
            </Menu.Item>
        </Menu>
    );

    const mobileMenu = (
        <Menu onClick={onClick} mode="inline" style={{ border: 'none' }}>
            <SubMenu icon={<ZhihuOutlined />} key={'languages'} title={t('Language')}>
                <Menu.Item key="en">
                    English
                </Menu.Item>
                <Menu.Item key="tr">
                    Türkçe
                </Menu.Item>
            </SubMenu>
            <Menu.Item key="dictionary" icon={<TranslationOutlined />}>
                {t('Dictionary')}
            </Menu.Item>
            <Menu.Item key="download-viewer" icon={<DownloadOutlined />}>
                <a href={`${window.AppSettings.server.api}/Public/launcher/ECloudpacsViewerInstaller.exe`} download>
                    {t('Viewer Download (Windows)')}
                </a>
            </Menu.Item>
            <Menu.Item key="logout" icon={<UserOutlined />} danger>
                {t('Logout')}
            </Menu.Item>
        </Menu>
    );

    return (
        <>
            {
                !isSmallScreen && (
                    <Dropdown overlay={menu} placement="bottomCenter" icon={<UserOutlined />}>
                        <Button>
                            <UserOutlined />
                            {user && `${user.data.name}`}
                        </Button>
                    </Dropdown>
                )
            }
            {
                isSmallScreen && (
                    <>
                        <Button
                            type="text"
                            onClick={() => setDrawerOpen(true)}
                            style={{ color: '#fff', padding: '4px 8px' }}
                        >
                            <UserOutlined style={{ fontSize: 18 }} />
                        </Button>
                        <Drawer
                            title={user && user.data.name}
                            placement="right"
                            onClose={() => setDrawerOpen(false)}
                            open={drawerOpen}
                            width="280px"
                            styles={{
                                body: { padding: 0 },
                                header: { borderBottom: '1px solid #f0f0f0' }
                            }}
                        >
                            {mobileMenu}
                        </Drawer>
                    </>
                )
            }
        </>
    )
}
